export default __webpack_public_path__ + "static/media/Chill of Winter's Breath.15262be2.jpg";